export const SUNDAY = 'Sunday'
export const MONDAY = 'Monday'
export const TUESDAY = 'Tuesday'
export const WEDNESDAY = 'Wednesday'
export const THURSDAY = 'Thursday'
export const FRIDAY = 'Friday'
export const SATURDAY = 'Saturday'

export const RADIUS_TYPE_KM = 'KM'
export const RADIUS_TYPE_MILES = 'MI'

export const HTMLInputMapId = 'map-input-cities'
